export default __webpack_public_path__ + "static/media/eletric5.087676b3.jpeg";